import { Language } from './types';

// Environment Variables (Simulated for boilerplate)
// In a real Vercel env, use import.meta.env or process.env
export const API_URL = 'https://api.joisst.com';
export const APP_NAME = 'Joisst Sub-App';

export const DEFAULT_LANGUAGE = Language.EN;

export const ROUTES = {
  HOME: '/',
  DASHBOARD: '/dashboard',
  ADMIN: '/admin',
};

// Mocking the behavior if these were server-side env vars
export const MOCK_DB_DELAY_MS = 300;